/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionEntryType } from './CompetitionEntryType';
import {
    CompetitionEntryTypeFromJSON,
    CompetitionEntryTypeFromJSONTyped,
    CompetitionEntryTypeToJSON,
    CompetitionEntryTypeToJSONTyped,
} from './CompetitionEntryType';
import type { TournamentPlatform } from './TournamentPlatform';
import {
    TournamentPlatformFromJSON,
    TournamentPlatformFromJSONTyped,
    TournamentPlatformToJSON,
    TournamentPlatformToJSONTyped,
} from './TournamentPlatform';
import type { EntryFeeUnit } from './EntryFeeUnit';
import {
    EntryFeeUnitFromJSON,
    EntryFeeUnitFromJSONTyped,
    EntryFeeUnitToJSON,
    EntryFeeUnitToJSONTyped,
} from './EntryFeeUnit';
import type { TournamentPrizeSplit } from './TournamentPrizeSplit';
import {
    TournamentPrizeSplitFromJSON,
    TournamentPrizeSplitFromJSONTyped,
    TournamentPrizeSplitToJSON,
    TournamentPrizeSplitToJSONTyped,
} from './TournamentPrizeSplit';
import type { GlobalFilterExclusion } from './GlobalFilterExclusion';
import {
    GlobalFilterExclusionFromJSON,
    GlobalFilterExclusionFromJSONTyped,
    GlobalFilterExclusionToJSON,
    GlobalFilterExclusionToJSONTyped,
} from './GlobalFilterExclusion';
import type { TournamentRegion } from './TournamentRegion';
import {
    TournamentRegionFromJSON,
    TournamentRegionFromJSONTyped,
    TournamentRegionToJSON,
    TournamentRegionToJSONTyped,
} from './TournamentRegion';
import type { TournamentStatus } from './TournamentStatus';
import {
    TournamentStatusFromJSON,
    TournamentStatusFromJSONTyped,
    TournamentStatusToJSON,
    TournamentStatusToJSONTyped,
} from './TournamentStatus';
import type { TournamentFinalStanding } from './TournamentFinalStanding';
import {
    TournamentFinalStandingFromJSON,
    TournamentFinalStandingFromJSONTyped,
    TournamentFinalStandingToJSON,
    TournamentFinalStandingToJSONTyped,
} from './TournamentFinalStanding';
import type { BracketType } from './BracketType';
import {
    BracketTypeFromJSON,
    BracketTypeFromJSONTyped,
    BracketTypeToJSON,
    BracketTypeToJSONTyped,
} from './BracketType';
import type { TournamentBracket } from './TournamentBracket';
import {
    TournamentBracketFromJSON,
    TournamentBracketFromJSONTyped,
    TournamentBracketToJSON,
    TournamentBracketToJSONTyped,
} from './TournamentBracket';
import type { PrerequisiteResponse } from './PrerequisiteResponse';
import {
    PrerequisiteResponseFromJSON,
    PrerequisiteResponseFromJSONTyped,
    PrerequisiteResponseToJSON,
    PrerequisiteResponseToJSONTyped,
} from './PrerequisiteResponse';
import type { TournamentFeeMode } from './TournamentFeeMode';
import {
    TournamentFeeModeFromJSON,
    TournamentFeeModeFromJSONTyped,
    TournamentFeeModeToJSON,
    TournamentFeeModeToJSONTyped,
} from './TournamentFeeMode';
import type { EntryFeeConfigResponse } from './EntryFeeConfigResponse';
import {
    EntryFeeConfigResponseFromJSON,
    EntryFeeConfigResponseFromJSONTyped,
    EntryFeeConfigResponseToJSON,
    EntryFeeConfigResponseToJSONTyped,
} from './EntryFeeConfigResponse';
import type { TournamentCurrency } from './TournamentCurrency';
import {
    TournamentCurrencyFromJSON,
    TournamentCurrencyFromJSONTyped,
    TournamentCurrencyToJSON,
    TournamentCurrencyToJSONTyped,
} from './TournamentCurrency';
import type { TournamentPrivacy } from './TournamentPrivacy';
import {
    TournamentPrivacyFromJSON,
    TournamentPrivacyFromJSONTyped,
    TournamentPrivacyToJSON,
    TournamentPrivacyToJSONTyped,
} from './TournamentPrivacy';
import type { TournamentPrizePool } from './TournamentPrizePool';
import {
    TournamentPrizePoolFromJSON,
    TournamentPrizePoolFromJSONTyped,
    TournamentPrizePoolToJSON,
    TournamentPrizePoolToJSONTyped,
} from './TournamentPrizePool';
import type { TournamentSkillLevel } from './TournamentSkillLevel';
import {
    TournamentSkillLevelFromJSON,
    TournamentSkillLevelFromJSONTyped,
    TournamentSkillLevelToJSON,
    TournamentSkillLevelToJSONTyped,
} from './TournamentSkillLevel';

/**
 * Tournament instance created from a challenge template
 * @export
 * @interface Tournament
 */
export interface Tournament {
    /**
     * Tournament ID
     * @type {string}
     * @memberof Tournament
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof Tournament
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof Tournament
     */
    updatedAt: number;
    /**
     * Reference to parent ChallengeConfig
     * @type {string}
     * @memberof Tournament
     */
    challengeId?: string;
    /**
     * 
     * @type {string}
     * @memberof Tournament
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Tournament
     */
    description?: string;
    /**
     * Reference to OWGame
     * @type {string}
     * @memberof Tournament
     */
    gameId?: string;
    /**
     * 
     * @type {BracketType}
     * @memberof Tournament
     */
    bracketType?: BracketType;
    /**
     * 1 for solo, 2-5 for teams
     * @type {number}
     * @memberof Tournament
     */
    teamSize: number;
    /**
     * 
     * @type {number}
     * @memberof Tournament
     */
    maxTeams: number;
    /**
     * 
     * @type {number}
     * @memberof Tournament
     */
    minTeams: number;
    /**
     * 
     * @type {number}
     * @memberof Tournament
     */
    registrationOpens?: number;
    /**
     * 
     * @type {number}
     * @memberof Tournament
     */
    registrationCloses?: number;
    /**
     * 
     * @type {number}
     * @memberof Tournament
     */
    startTime?: number;
    /**
     * 
     * @type {number}
     * @memberof Tournament
     */
    endTime?: number;
    /**
     * 
     * @type {TournamentStatus}
     * @memberof Tournament
     */
    status: TournamentStatus;
    /**
     * 
     * @type {CompetitionEntryType}
     * @memberof Tournament
     */
    entryType?: CompetitionEntryType;
    /**
     * 
     * @type {EntryFeeConfigResponse}
     * @memberof Tournament
     */
    entryFeeConfig?: EntryFeeConfigResponse;
    /**
     * Entry fee amount in FUEL (0 for free). Read-side convenience during the EntryFeeConfig conversion — entryFeeConfig is authoritative.
     * @type {number}
     * @memberof Tournament
     */
    entryFee?: number;
    /**
     * 
     * @type {TournamentCurrency}
     * @memberof Tournament
     */
    entryFeeCurrency?: TournamentCurrency;
    /**
     * 
     * @type {EntryFeeUnit}
     * @memberof Tournament
     */
    entryFeeUnit?: EntryFeeUnit;
    /**
     * 
     * @type {TournamentFeeMode}
     * @memberof Tournament
     */
    feeMode?: TournamentFeeMode;
    /**
     * 
     * @type {TournamentPrizeSplit}
     * @memberof Tournament
     */
    prizeSplit?: TournamentPrizeSplit;
    /**
     * 
     * @type {TournamentPrizePool}
     * @memberof Tournament
     */
    prizePool?: TournamentPrizePool;
    /**
     * Prizes only pay out if at least this many competed. Distinct from minTeams, which gates whether the tournament can start.
     * @type {number}
     * @memberof Tournament
     */
    minParticipants?: number;
    /**
     * Receives no writes from any payment route — retained for legacy display only. The pool is derived from the Fuel ledger by PrizePoolService.derivePrizePool.
     * @type {number}
     * @memberof Tournament
     */
    collectedPrizePool?: number;
    /**
     * 
     * @type {TournamentBracket}
     * @memberof Tournament
     */
    bracket?: TournamentBracket;
    /**
     * 
     * @type {Array<string>}
     * @memberof Tournament
     */
    registeredTeams?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof Tournament
     */
    registeredTeamsCount?: number;
    /**
     * 
     * @type {Array<TournamentFinalStanding>}
     * @memberof Tournament
     */
    finalStandings?: Array<TournamentFinalStanding>;
    /**
     * 
     * @type {string}
     * @memberof Tournament
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof Tournament
     */
    sponsorId?: string;
    /**
     * 
     * @type {TournamentPlatform}
     * @memberof Tournament
     */
    platform?: TournamentPlatform;
    /**
     * 
     * @type {TournamentRegion}
     * @memberof Tournament
     */
    region?: TournamentRegion;
    /**
     * 
     * @type {TournamentPrivacy}
     * @memberof Tournament
     */
    privacy?: TournamentPrivacy;
    /**
     * 
     * @type {TournamentSkillLevel}
     * @memberof Tournament
     */
    skillLevel?: TournamentSkillLevel;
    /**
     * Minimum age required (0 for no restriction)
     * @type {number}
     * @memberof Tournament
     */
    ageRestriction?: number;
    /**
     * Whether teams must check in before tournament starts
     * @type {boolean}
     * @memberof Tournament
     */
    checkInRequired?: boolean;
    /**
     * Minutes before start time that check-in opens
     * @type {number}
     * @memberof Tournament
     */
    checkInWindowMinutes?: number;
    /**
     * URL for tournament stream (Twitch, YouTube, etc.)
     * @type {string}
     * @memberof Tournament
     */
    streamUrl?: string;
    /**
     * Discord server invite link for tournament communication
     * @type {string}
     * @memberof Tournament
     */
    discordUrl?: string;
    /**
     * Contact email for tournament inquiries
     * @type {string}
     * @memberof Tournament
     */
    contactEmail?: string;
    /**
     * Banner/header image URL for tournament
     * @type {string}
     * @memberof Tournament
     */
    imageUrl?: string;
    /**
     * 
     * @type {Array<PrerequisiteResponse>}
     * @memberof Tournament
     */
    prerequisites?: Array<PrerequisiteResponse>;
    /**
     * IDs of EventPipelineFilter documents applied to this tournament's events. Layered on top of the game-wide global filter; blocks when any assigned filter votes BLOCK (conditions AND-compose within each filter; exclude conditions block on match, include conditions block on non-match).
     * @type {Array<string>}
     * @memberof Tournament
     */
    appliedFilterIds?: Array<string>;
    /**
     * Break-glass per-entity exclusions of GLOBAL filters for this tournament (PRODUCT_PLAN D2(b)). Each entry names one global filter this tournament opts out of, with a required reason; with no end date the skip lasts for the life of the entity. Evaluated as set membership against the blocking lines stamped on the fan-out message.
     * @type {Array<GlobalFilterExclusion>}
     * @memberof Tournament
     */
    excludedGlobalFilters?: Array<GlobalFilterExclusion>;
    /**
     * Rule 4 opt-out. When true this tournament still scores events whose match context is missing (the pre-Rule-4 behavior). Default false — a tournament that declares what counts should not score events that cannot prove they qualify.
     * @type {boolean}
     * @memberof Tournament
     */
    failOpenOnMissingContext?: boolean;
    /**
     * Cheat-filtering match-bracketing gate — requires active Match Start / Round Start in Redis to score
     * @type {boolean}
     * @memberof Tournament
     */
    requireActiveMatch?: boolean;
    /**
     * Derived from prizePool.guaranteedPoolUsd — true when Devour has committed a funded base, meaning the pool pays out in full regardless of entry count. Not writable; set guaranteedPoolUsd instead.
     * @type {boolean}
     * @memberof Tournament
     */
    readonly guaranteedPrize?: boolean;
}



/**
 * Check if a given object implements the Tournament interface.
 */
export function instanceOfTournament(value: object): value is Tournament {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('teamSize' in value) || value['teamSize'] === undefined) return false;
    if (!('maxTeams' in value) || value['maxTeams'] === undefined) return false;
    if (!('minTeams' in value) || value['minTeams'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function TournamentFromJSON(json: any): Tournament {
    return TournamentFromJSONTyped(json, false);
}

export function TournamentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tournament {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'challengeId': json['challengeId'] == null ? undefined : json['challengeId'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'bracketType': json['bracketType'] == null ? undefined : BracketTypeFromJSON(json['bracketType']),
        'teamSize': json['teamSize'],
        'maxTeams': json['maxTeams'],
        'minTeams': json['minTeams'],
        'registrationOpens': json['registrationOpens'] == null ? undefined : json['registrationOpens'],
        'registrationCloses': json['registrationCloses'] == null ? undefined : json['registrationCloses'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'status': TournamentStatusFromJSON(json['status']),
        'entryType': json['entryType'] == null ? undefined : CompetitionEntryTypeFromJSON(json['entryType']),
        'entryFeeConfig': json['entryFeeConfig'] == null ? undefined : EntryFeeConfigResponseFromJSON(json['entryFeeConfig']),
        'entryFee': json['entryFee'] == null ? undefined : json['entryFee'],
        'entryFeeCurrency': json['entryFeeCurrency'] == null ? undefined : TournamentCurrencyFromJSON(json['entryFeeCurrency']),
        'entryFeeUnit': json['entryFeeUnit'] == null ? undefined : EntryFeeUnitFromJSON(json['entryFeeUnit']),
        'feeMode': json['feeMode'] == null ? undefined : TournamentFeeModeFromJSON(json['feeMode']),
        'prizeSplit': json['prizeSplit'] == null ? undefined : TournamentPrizeSplitFromJSON(json['prizeSplit']),
        'prizePool': json['prizePool'] == null ? undefined : TournamentPrizePoolFromJSON(json['prizePool']),
        'minParticipants': json['minParticipants'] == null ? undefined : json['minParticipants'],
        'collectedPrizePool': json['collectedPrizePool'] == null ? undefined : json['collectedPrizePool'],
        'bracket': json['bracket'] == null ? undefined : TournamentBracketFromJSON(json['bracket']),
        'registeredTeams': json['registeredTeams'] == null ? undefined : json['registeredTeams'],
        'registeredTeamsCount': json['registeredTeamsCount'] == null ? undefined : json['registeredTeamsCount'],
        'finalStandings': json['finalStandings'] == null ? undefined : ((json['finalStandings'] as Array<any>).map(TournamentFinalStandingFromJSON)),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'sponsorId': json['sponsorId'] == null ? undefined : json['sponsorId'],
        'platform': json['platform'] == null ? undefined : TournamentPlatformFromJSON(json['platform']),
        'region': json['region'] == null ? undefined : TournamentRegionFromJSON(json['region']),
        'privacy': json['privacy'] == null ? undefined : TournamentPrivacyFromJSON(json['privacy']),
        'skillLevel': json['skillLevel'] == null ? undefined : TournamentSkillLevelFromJSON(json['skillLevel']),
        'ageRestriction': json['ageRestriction'] == null ? undefined : json['ageRestriction'],
        'checkInRequired': json['checkInRequired'] == null ? undefined : json['checkInRequired'],
        'checkInWindowMinutes': json['checkInWindowMinutes'] == null ? undefined : json['checkInWindowMinutes'],
        'streamUrl': json['streamUrl'] == null ? undefined : json['streamUrl'],
        'discordUrl': json['discordUrl'] == null ? undefined : json['discordUrl'],
        'contactEmail': json['contactEmail'] == null ? undefined : json['contactEmail'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'prerequisites': json['prerequisites'] == null ? undefined : ((json['prerequisites'] as Array<any>).map(PrerequisiteResponseFromJSON)),
        'appliedFilterIds': json['appliedFilterIds'] == null ? undefined : json['appliedFilterIds'],
        'excludedGlobalFilters': json['excludedGlobalFilters'] == null ? undefined : ((json['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionFromJSON)),
        'failOpenOnMissingContext': json['failOpenOnMissingContext'] == null ? undefined : json['failOpenOnMissingContext'],
        'requireActiveMatch': json['requireActiveMatch'] == null ? undefined : json['requireActiveMatch'],
        'guaranteedPrize': json['guaranteedPrize'] == null ? undefined : json['guaranteedPrize'],
    };
}

export function TournamentToJSON(json: any): Tournament {
    return TournamentToJSONTyped(json, false);
}

export function TournamentToJSONTyped(value?: Omit<Tournament, 'guaranteedPrize'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'challengeId': value['challengeId'],
        'name': value['name'],
        'description': value['description'],
        'gameId': value['gameId'],
        'bracketType': BracketTypeToJSON(value['bracketType']),
        'teamSize': value['teamSize'],
        'maxTeams': value['maxTeams'],
        'minTeams': value['minTeams'],
        'registrationOpens': value['registrationOpens'],
        'registrationCloses': value['registrationCloses'],
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'status': TournamentStatusToJSON(value['status']),
        'entryType': CompetitionEntryTypeToJSON(value['entryType']),
        'entryFeeConfig': EntryFeeConfigResponseToJSON(value['entryFeeConfig']),
        'entryFee': value['entryFee'],
        'entryFeeCurrency': TournamentCurrencyToJSON(value['entryFeeCurrency']),
        'entryFeeUnit': EntryFeeUnitToJSON(value['entryFeeUnit']),
        'feeMode': TournamentFeeModeToJSON(value['feeMode']),
        'prizeSplit': TournamentPrizeSplitToJSON(value['prizeSplit']),
        'prizePool': TournamentPrizePoolToJSON(value['prizePool']),
        'minParticipants': value['minParticipants'],
        'collectedPrizePool': value['collectedPrizePool'],
        'bracket': TournamentBracketToJSON(value['bracket']),
        'registeredTeams': value['registeredTeams'],
        'registeredTeamsCount': value['registeredTeamsCount'],
        'finalStandings': value['finalStandings'] == null ? undefined : ((value['finalStandings'] as Array<any>).map(TournamentFinalStandingToJSON)),
        'createdBy': value['createdBy'],
        'sponsorId': value['sponsorId'],
        'platform': TournamentPlatformToJSON(value['platform']),
        'region': TournamentRegionToJSON(value['region']),
        'privacy': TournamentPrivacyToJSON(value['privacy']),
        'skillLevel': TournamentSkillLevelToJSON(value['skillLevel']),
        'ageRestriction': value['ageRestriction'],
        'checkInRequired': value['checkInRequired'],
        'checkInWindowMinutes': value['checkInWindowMinutes'],
        'streamUrl': value['streamUrl'],
        'discordUrl': value['discordUrl'],
        'contactEmail': value['contactEmail'],
        'imageUrl': value['imageUrl'],
        'prerequisites': value['prerequisites'] == null ? undefined : ((value['prerequisites'] as Array<any>).map(PrerequisiteResponseToJSON)),
        'appliedFilterIds': value['appliedFilterIds'],
        'excludedGlobalFilters': value['excludedGlobalFilters'] == null ? undefined : ((value['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionToJSON)),
        'failOpenOnMissingContext': value['failOpenOnMissingContext'],
        'requireActiveMatch': value['requireActiveMatch'],
    };
}

